import React from "react";
import Index from "./routes/Index";

const App = () => {
  return (
    <div>
      <Index />
    </div>
  );
};

export default App;
